export default __webpack_public_path__ + "static/media/Need_help_icon_1.7ed65139.svg";